module.exports = __webpack_public_path__ + "static/img/1070_phase_function_Paper_Points.1778f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1070_phase_function_Paper_Points.png
// module id = QzFw
// module chunks = 0